/* unplugin-vue-components disabled */import { ElTag as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/ep/refresh';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-407c91a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "title-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "第二步：支付测试"), /*#__PURE__*/_createElementVNode("span", {
  class: "desc"
}, "母包进行支付测试，若下单成功，下方会展示已经生成的订单信息。")], -1));
const _hoisted_3 = {
  class: "desc-container"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "配置测试账号（支付测试时母包的登录账号必须与【游戏配置】中的测试账号保持一致） ", -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "配置测试支付商品（游戏商品ID必须与母包设置的商品ID一致）", -1));
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkGetPayList, apiUsdkBatchGetGameInfo, apiUsdkGetTestAccountList, apiUsdkGoodsList } from '@/api/usdk';
import warningIcon from '@/assets/svg/warning.svg';
import successIcon from '@/assets/svg/success.svg';
import AddAccountModal from './addAccountModal.vue';
import AddCallback from '../gameConf/addCallback.vue';
import AddGameGoodsModal from './addGameGoodsModal.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'orderTable',
  props: {
    gameInfo: {
      type: Object
    },
    height: {
      type: Number
    }
  },
  setup(__props) {
    const props = __props;
    const columns = ref([{
      label: '用户ID',
      prop: 'uid'
    }, {
      label: '用户名',
      prop: 'user'
    }, {
      label: '商品ID',
      prop: 'goodsId'
    }, {
      label: '商品名称',
      prop: 'goodsName'
    }, {
      label: '商品金额',
      prop: 'price',
      slot: 'price'
    }, {
      label: '下单时间',
      prop: 'createTime',
      width: '200px'
    }, {
      label: '订单状态',
      prop: 'status',
      slot: 'status'
    }]);
    // 获取订单列表
    const getTableData = async () => {
      const params = {
        gid: props.gameInfo && props.gameInfo.Id
      };
      tableLoading.value = true;
      apiUsdkGetPayList(params).then(res => {
        if (res.code === 0) {
          tableData.value = res.data;
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const addAccountModelRef = ref(null);
    const addCallbackRef = ref(null);
    const addGameGoodsModalRef = ref(null);
    const handleOpenModal = type => {
      if (type === 'addAccount') {
        addAccountModelRef.value.openModal();
      }
      if (type === 'addCallback') {
        addCallbackRef.value.show();
      }
      if (type === 'addGameGoods') {
        addGameGoodsModalRef.value.openModal();
      }
    };
    const isShowCallback = ref(false);
    const isShowTestAccount = ref(false);
    const isShowTestGoods = ref(false);
    const getGameInfo = () => {
      var _props$gameInfo;
      apiUsdkBatchGetGameInfo({
        gids: (_props$gameInfo = props.gameInfo) === null || _props$gameInfo === void 0 ? void 0 : _props$gameInfo.Id
      }).then(res => {
        if (res.code == 0 && res.data.length) {
          isShowCallback.value = !!res.data[0].callbackUrl;
        }
      });
    };
    const getTestAccountTableData = async () => {
      var _props$gameInfo2;
      apiUsdkGetTestAccountList({
        gid: (_props$gameInfo2 = props.gameInfo) === null || _props$gameInfo2 === void 0 ? void 0 : _props$gameInfo2.Id
      }).then(res => {
        if (res.code === 0) {
          isShowTestAccount.value = !!res.data.list.length;
        }
      });
    };
    const getTestGoodsData = async () => {
      var _props$gameInfo3;
      const res = await apiUsdkGoodsList({
        gid: (_props$gameInfo3 = props.gameInfo) === null || _props$gameInfo3 === void 0 ? void 0 : _props$gameInfo3.Id,
        Page: 1,
        PageSize: 10
      });
      if (res.code === 0) {
        isShowTestGoods.value = !!res.data.length;
      }
    };
    watch(() => props.gameInfo, val => {
      if (val.Id) {
        getTableData();
        getGameInfo();
        getTestAccountTableData();
        getTestGoodsData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_i_ep_Refresh = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_el_tag = __unplugin_components_2;
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createBlock(_component_u_card, {
        class: "marginT20",
        disabled: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [!_unref(isShowTestAccount) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(warningIcon),
          alt: ""
        }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          style: {
            "width": "14px",
            "margin-left": "1px"
          },
          src: _unref(successIcon),
          alt: ""
        }, null, 8, _hoisted_6)), _hoisted_7, _createElementVNode("span", {
          class: "btn",
          onClick: _cache[0] || (_cache[0] = $event => handleOpenModal('addAccount'))
        }, "添加账号"), !_unref(isShowCallback) ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          style: {
            "margin-left": "10px"
          },
          src: _unref(warningIcon),
          alt: ""
        }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("img", {
          key: 3,
          style: {
            "margin-left": "10px",
            "width": "14px"
          },
          src: _unref(successIcon),
          alt: ""
        }, null, 8, _hoisted_9)), _createTextVNode(" 配置支付回调地址（用于接收支付通知结果） "), _createElementVNode("span", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = $event => handleOpenModal('addCallback'))
        }, "配置回调地址")]), _createElementVNode("div", _hoisted_10, [_unref(isShowTestGoods) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          style: {
            "width": "14px",
            "margin-left": "1px"
          },
          src: _unref(successIcon),
          alt: ""
        }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          style: {
            "width": "14px",
            "margin-left": "1px"
          },
          src: _unref(warningIcon),
          alt: ""
        }, null, 8, _hoisted_12)), _hoisted_13, _createElementVNode("span", {
          class: "btn",
          onClick: _cache[2] || (_cache[2] = $event => handleOpenModal('addGameGoods'))
        }, "配置商品")])])])]),
        extra: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "cp",
          size: 20,
          onClick: getTableData
        }, {
          default: _withCtx(() => [_createVNode(_component_i_ep_Refresh)]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(UTable, {
          options: _unref(columns),
          data: _unref(tableData),
          loading: _unref(tableLoading),
          height: __props.height
        }, {
          status: _withCtx(() => [_createVNode(_component_el_tag, {
            type: "success"
          }, {
            default: _withCtx(() => [_createTextVNode("成功")]),
            _: 1
          })]),
          price: _withCtx(({
            scope
          }) => [_createTextVNode(_toDisplayString(scope.row.price) + " 元 ", 1)]),
          _: 1
        }, 8, ["options", "data", "loading", "height"]), _createVNode(AddAccountModal, {
          ref_key: "addAccountModelRef",
          ref: addAccountModelRef,
          gameInfo: __props.gameInfo
        }, null, 8, ["gameInfo"]), _createVNode(AddCallback, {
          ref_key: "addCallbackRef",
          ref: addCallbackRef,
          gameInfo: __props.gameInfo
        }, null, 8, ["gameInfo"]), _createVNode(AddGameGoodsModal, {
          ref_key: "addGameGoodsModalRef",
          ref: addGameGoodsModalRef,
          gameInfo: __props.gameInfo
        }, null, 8, ["gameInfo"])]),
        _: 1
      });
    };
  }
});